import React from "react";
import { MenuIcon } from "lucide-react";

const Navbar = ({ toggleSidebar, user }) => (
  <div className="bg-white dark:bg-gray-800 shadow p-4 flex justify-between items-center">
    <button onClick={toggleSidebar} className="md:hidden">
      <MenuIcon />
    </button>
    <h1 className="text-xl font-bold">Internet Billing Management</h1>
    {user && (
      <div className="text-sm font-medium text-gray-700 dark:text-gray-200">
        {user.last_name}
      </div>
    )}
  </div>
);

export default Navbar;
